import { render } from "./ChampionTrends.vue?vue&type=template&id=300855cc&scoped=true"
import script from "./ChampionTrends.vue?vue&type=script&lang=ts"
export * from "./ChampionTrends.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-300855cc"

export default script